import {
  FETCH_REPORT_ANALYTICS, UPDATE_REPORT_ANALYTICS_PAGE_OPTIONS, SET_REPORT_ANALYTICS_FILTERS, FETCH_STATEFARM_DASHBOARD,
} from 'constants/ActionTypes';
import { all, takeLatest } from 'lib/redux';
import { takeEvery } from 'redux-saga/effects';
import {
  fetchReportAnalyticsSaga, setReportAnalyticsFiltersSaga, updateReportAnalyticsPageOptionsSaga, fetchStatefarmDashboardSaga,
} from './AnalyticsDashboard.saga';

export default function* watchers() {
  yield all([
    takeLatest(FETCH_REPORT_ANALYTICS, fetchReportAnalyticsSaga),
    takeEvery(UPDATE_REPORT_ANALYTICS_PAGE_OPTIONS, updateReportAnalyticsPageOptionsSaga),
    takeEvery(SET_REPORT_ANALYTICS_FILTERS, setReportAnalyticsFiltersSaga),
    takeLatest(FETCH_STATEFARM_DASHBOARD, fetchStatefarmDashboardSaga),
  ]);
}
